/** 收益页 **/
<template>
  <div class="home">
    <Layout
      type="REVENUE"
      isRevenue="true"
      :pageTitle="$t('menu.revenueDetails')"
    >
      <BasiceLayout
        :title="$t('layoutTitle')"
        class="revenue-layout"
      >
        <div class="revenue-detail-select">
          <div
            v-if="bxc"
            class="detail-total-revenue margin-20"
          >{{$t('tolal_revenue')}}: &nbsp; &nbsp; {{bxc.toFixed(6)}}</div>
          <span class="revenue-date-wrap">{{$t('revenueDate')}}:</span>
          <el-select
            v-model="selectDate"
            filterable
            @change="search"
          >
            <el-option
              v-for="item in queryDate"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <span class="search-text">{{$t('search_mac_address')}}</span>
          <!-- <el-select
            v-model="searchMacAddress"
            filterable
            placeholder=""
            @change="searchMac"
          >
            <el-option
              v-for="item in allDevices"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <el-input
            class="search-mac-input"
            v-model="searchMacAddress"
            placeholder=""
            @change="searchMac"
          ></el-input>

          <div
            class="button export-button"
            @click="exportRevenue(1, 200, [])"
          >{{ $t('export') }}</div>
        </div>
        <el-table
          v-if="detailList !== 'NO_CONTENT'"
          :data="detailList"
          align="left"
          empty-text="-"
          style="width: 100%"
        >
          <!-- mac address -->
          <el-table-column
            prop="mac_address"
            align='center'
            :label="$t('mac_address')"
          >
          </el-table-column>
          <!-- 备注 -->
          <el-table-column
            :label="$t('noteText')"
            align='center'
          >
            <template slot-scope="scope">
              <div v-if="scope.row.note">{{scope.row.note}}</div>
              <div
                v-if="!scope.row.note"
                :deviceId="scope.row.deviceId"
                @click="showNotes(scope.row.id, scope.row.mac_address)"
                class="add-note-button button bonus-cursor"
              >
                {{$t('addNote')}}</div>
              <i
                v-if="scope.row.note && scope.row.noteStatus"
                class="el-icon-edit"
                @click="showNotes(scope.row.id, scope.row.mac_address)"
              ></i>
            </template>
          </el-table-column>
          <!-- 设备收益 -->
          <el-table-column
            prop="revenue"
            align='center'
            :label="$t('device_revenue')"
          >
          </el-table-column>
          <!-- 历史收益 -->
          <el-table-column
            align='center'
            label="历史收益"
          >
            <template slot-scope="scope">
              <img
                class="watch-icon"
                @click="showDeviceRevenue(scope.row.id)"
                src="../../../assets/revenueBlack.png"
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-if="detailList === 'NO_CONTENT'"
          :data="detailList"
          align="left"
          empty-text="system upgrade.."
          style="width: 100%"
        >
        </el-table>
        <div
          class="pagination"
          v-if="deviceNumSize > 1"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="deviceNumSize"
            layout="total, prev, pager, next"
            :total="deviceLength"
          >
          </el-pagination>
        </div>
        <!-- 增加备注 -->
        <el-dialog
          :title="$t('addNotes.title')"
          :visible.sync="showAddnoteDialog"
          width="480px"
          center
        >
          <div class="addnote-dialog-wrap">
            <span class="key">{{$t('addNotes.tipText')}}({{addNoteAddress}})</span>
            <input
              type="text"
              class="basic-input input addnote-input"
              v-model="addNoteInput"
            >
          </div>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <div
              class="sure-unbind button"
              @click="showAddnoteDialog = false"
            >{{ $t('cancel') }}</div>
            <div
              class="sure-unbind button"
              type="primary"
              @click="addNote"
            >{{ $t('confirm') }}</div>
          </span>
        </el-dialog>
      </BasiceLayout>
    </Layout>

    <!-- 增加备注 -->
    <el-dialog
      title="历史收益"
      :visible.sync="showLastRevenueDialog"
      width="70%"
      center
    >
      <div class="addnote-dialog-wrap">
        <LineCharts :chartData="chartData"></LineCharts>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="showLastRevenueDialog = false"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Layout from "@/components/DatePanel/Layout.vue";
import RevenueContent from "@/components/RevenueDetail/RevenueContent.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import LineCharts from "@/components/Common/LineCharts.vue";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { Message, Loading } from "element-ui";
const type = "all";

export default {
  name: "home",
  data() {
    return {
      selectDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      pageNum: 1,
      addNoteInput: "",
      addNoteAddress: "", //添加备注Id
      showAddnoteDialog: false,
      searchMacAddress: "",
      defaultDate: moment().utc().startOf("day").format("YYYY-MM-DD"),
      showLastRevenueDialog: false,
      chartData: {}
    };
  },
  components: {
    Header,
    Layout,
    BasiceLayout,
    LineCharts
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    deviceLength: (state) => state.revenueDetail.deviceLength,
    currentPage: (state) => state.revenueDetail.currentPage,
    deviceNumSize: (state) => state.revenueDetail.deviceNumSize,
    detailList: (state) => state.revenueDetail.detailList,
    allDevices: (state) => state.revenueDetail.allDevices,
    detailOnlineBxc: (state) => state.revenueDetail.detailOnlineBxc,
    bxc: (state) => state.revenueDetail.bxc,
    queryDate: () => {
      let queryDate = [];
      let endDay = moment().utc().startOf("day");

      endDay -= 24 * 60 * 60 * 1000;
      let i = 0;
      while (i < 7) {
        i++;
        queryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }

      return queryDate;
    },
  }),
  created() {
    let queryDate = moment()
      .utc()
      .startOf("day")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.queryDate = queryDate;
    let pageNum = this.pageNum;

    this.getRevenueDetail({ queryDate, pageNum, type, deviceType: "lite" });
  },
  methods: {
    ...mapActions(["getRevenueDetail", "addDeviceNotes", "getLastSevenRevenue"]),
    // 日期搜索
    search(queryDate) {
      this.queryDate = queryDate;
      let pageNum = this.pageNum;
      this.getRevenueDetail({ queryDate, pageNum, type, deviceType: "lite" });
    },
    // mac搜索
    searchMac(mac_address) {
      let { selectDate, pageNum = 1 } = this;
      this.getRevenueDetail({
        pageNum,
        mac_address,
        queryDate: selectDate,
        type,
        deviceType: "lite",
      });
    },
    handleCurrentChange(value) {
      let queryDate = this.selectDate || this.defaultDate;
      this.pageNum = value;
      this.getRevenueDetail({
        queryDate,
        pageNum: value,
        type,
        deviceType: "lite",
      });
    },
    // 添加备注
    addNote() {
      let that = this;
      this.addDeviceNotes({
        deviceId: this.addNoteId,
        note: this.addNoteInput,
      }).then((res) => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message,
          });
          that.showAddnoteDialog = false;
          if (that.searchMacAddress === "all" || that.searchMacAddress === "") {
            this.getRevenueDetail({
              type,
              queryDate: that.selectDate,
              pageNum: that.pageNum,
              deviceType: "lite",
            });
          } else {
            this.getDeviceDetail({ id: that.searchMacAddress });
          }
        } else {
          Message({
            type: "error",
            message: res.message || "add note error",
          });
        }
      });
    },
    // 备注框
    showNotes(id, address) {
      this.showAddnoteDialog = true;
      this.addNoteId = id;
      this.addNoteAddress = address;
    },
    // 导出硬件列表
    exportRevenue(pageNum, pageSize, hardList = []) {
      const that = this;
      (pageSize = pageSize || 200), (pageNum = pageNum || 1);

      let queryDate = this.selectDate || this.defaultDate;
      // loading效果
      let loadingInstance = Loading.service({
        fullscreen: true,
        background: "rgba(0, 0, 0, 0.8)",
      });

      this.getRevenueDetail({
        pageNum,
        pageSize,
        type: "all",
        queryDate,
        GETRESULT: "true",
      }).then((result) => {
        if (result && result.detailList) {
          let length = result.deviceLength;
          hardList = hardList.concat(result.detailList);

          if (hardList.length === length) {
            import("@/vendor/Export2Excel").then((excel) => {
              const tHeader = that.$t("excelHeaders").split("&");
              const filterVal = [
                "mac_address",
                "note",
                "revenue",
                "networkRevenue",
                "calculateRevenue",
              ];
              const list = hardList;
              const data = list.map((v) => filterVal.map((j) => v[j]));

              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "revenue",
                autoWidth: true,
                bookType: "xlsx",
              });
              // 关闭loading
              loadingInstance.close();
            });
          } else {
            that.exportRevenue(pageNum + 1, pageSize, hardList);
          }
        } else {
          loadingInstance.close();
        }
      });
    },
    showDeviceRevenue(deviceId) {
      this.getLastSevenRevenue({deviceId}).then(res => {
        this.showLastRevenueDialog = true;
        // this.selectedDeviceId = deviceId;
        if (res && res.data) {
          let data = res.data;
          let chartData = {
            columns: ['日期', '当日总收益预估（BP）'],
            rows: []
          };
          for (let i in data) {
            let item = data[i];
            chartData.rows.push({
              '日期': moment(Number(i)).format('YYYY MM DD'),
              '当日总收益预估（BP）': item.bxc,
            })
          }

          this.chartData = chartData;

        }
      });
    }
  },
};
</script>

<style lang="stylus">
.data-panel-wrap, .data-panel-layout, .home {
  height: 100%;
}

.revenue-all-layout {
  height: 100%;
}

.revenue-date-wrap {
  margin: 0 20px;
}

.revenue-detail-select {
  text-align: left;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #ddd;
}

.revenue-tips {
  display: inline-block;
  margin: 0 20px;
  color: #96999b;
}

.add-note-button {
  max-width: 80px;
}
</style>

<i18n>
    {
    "zn": {
      "layoutTitle": "设备收益详情",
      "revenueDate": "查询日期（UTC）",
      "revenueMac": "查询MAC地址",
      "mac_address": "设备",
      "device_revenue": "设备收益",
      "noteText": "备注",
      "search_mac_address": "搜索Mac地址",
      "noteText": "备注",
      "allSearch": "全部",
      "tolal_revenue": "当日设备总收益预估",
      "excelHeaders": "Mac地址&备注&设备总收益&网络任务收益&计算任务收益"
    },
    "en": {
      "layoutTitle": "Device Revenue Detatils",
      "revenueDate": "Date（UTC）",
      "revenueMac": "Mac Address",
      "mac_address": "Mac Address",
      "device_revenue": "device revenue",
      "search_mac_address": "Mac Address",
      "noteText": "note",
      "allSearch": "All",
      "tolal_revenue": "Total Revenue",
      "excelHeaders": "Mac Address&Notes&Device Revenue&Network Task Revenue&Computing task revenue"  
    }
  }
</i18n>
